import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListReviewerReviewedClipsV1Query } from './list-reviewer-reviewed-clips-v1-request';
import type { IListReviewerReviewedClipsV1Response } from './list-reviewer-reviewed-clips-v1-response';
import { listReviewerReviewedClipsV1ResponseSchema } from './list-reviewer-reviewed-clips-v1-response';

export async function listReviewerReviewedClipsV1Api(
  query: IListReviewerReviewedClipsV1Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListReviewerReviewedClipsV1Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  params.set('action', query.action);
  if (query.limit != null) {
    params.set('limit', String(query.limit));
  }
  if (query.offset != null) {
    params.set('offset', String(query.offset));
  }
  return getRequest<IListReviewerReviewedClipsV1Response>({
    path: `/sys/reviewer-performance/v1/reviewed-clips?${params.toString()}`,
    schema: listReviewerReviewedClipsV1ResponseSchema,
    options,
  });
}
